import React, { createContext } from "react";

const ABMContext = createContext();

export default ABMContext;
